document.addEventListener('DOMContentLoaded', () => {


const key = 'locator_last_auto_open';
const lastOpened = Number(localStorage.getItem(key) || 0);
const oneDay = 24 * 60 * 60 * 1000;

if (
  !localStorage.getItem('selected_location') &&
  Date.now() - lastOpened >= oneDay
) {
  ModalLocator.show();
  localStorage.setItem(key, String(Date.now()));
}

  updateCollectionIconsTop();

  window.addEventListener('resize', updateCollectionIconsTop);

  const header = document.querySelector('#shopify-section-sections--19784076689665__header');

  if (header && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(updateCollectionIconsTop);
    observer.observe(header);
  }
});

function updateCollectionIconsTop() {
  const header = document.querySelector('#shopify-section-sections--19784076689665__header');
  const sticky = document.querySelector('#shopify-section-sections--19784076689665__collection_icons_LYrLpn');

  if (!header || !sticky) return;

  const headerHeight = header.getBoundingClientRect().height;

  // Si quieres dejar unos píxeles de separación, cambia el 0 por 5, 10, etc.
  sticky.style.top = `${headerHeight}px`;
}